// extracted by mini-css-extract-plugin
export var askAiIcon = "_o6-j";
export var category = "_o6-9";
export var categoryHeader = "_o6-e";
export var container = "_o6-0";
export var group = "_o6-a";
export var groupItems = "_o6-f";
export var groupSeparator = "_o6-k";
export var loading = "_o6-1";
export var noResults = "_o6-3";
export var placeholder = "_o6-2";
export var resultContent = "_o6-5";
export var resultIcon = "_o6-c";
export var resultItem = "_o6-g";
export var resultMeta = "_o6-8";
export var resultSubtitle = "_o6-7";
export var resultSuffix = "_o6-i";
export var resultTitle = "_o6-6";
export var resultsList = "_o6-4";
export var searchGroup = "_o6-d";
export var selected = "_o6-h";
export var subgroup = "_o6-b";